<template>
    <div class="w-full max-w-[24rem] md:max-w-[26rem] mx-auto">
        <InputTypes
            v-model:value="id"
            type="wording"
            label="身分證號碼"
        />
        <InputTypes
            v-model:value="account"
            type="password"
            label="帳號"
            placeholder="尚未設定帳號者，請先輸入身分證號碼(統一編號)"
            :errorMsg="errors.account"
            input-class="placeholder-text-xs"
            @validateValue="validateAccount"
        />
        <InputTypes
            v-model:value="password"
            type="password"
            label="密碼"
            :errorMsg="errors.password"
            @validateValue="validatePassword"
        />
        <InputTypes
            label="驗證碼"
            :errorMsg="errors.verifyCode"
        >
            <template #input>
                <InputIdentify
                    v-model:value="verifyCode"
                    v-model:reFresh="reFresh"
                    @validateValue="getIsPassverifyCode"
                />
            </template>
        </InputTypes>

        <div class="flex flex-col items-center justify-center mt-2">
            <button
                class="btn rounded-full gradient-primary border-0 max-w-[8.75rem] mb-6"
                @click.prevent="validValue"
            >
                登入
            </button>
            <button
                class="btn-text text-gray-700 text-[0.875rem] leading-none border-b-2 border-solid"
                @click.prevent="forgetPassword"
            >
                忘記密碼
            </button>
        </div>
    </div>
    <Loading :isLoading="isLoading" />
</template>

<script>
import { computed, onMounted, reactive, ref, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import routeName from '@/router/constant.js';
import InputTypes from '@/components/inputs/InputTypes.vue';
import InputIdentify from '@/components/inputs/InputIdentify.vue';
import { textLength } from '@/utils/rules/customRules';
import { postMemberVerifySubmit } from '@/apis/confirmAddrPhoneEmail';
import { postEncrypt } from '@/apis/eNotifyPromo';
import { openPopupCatchMessage } from '@/utils/vfmUtils';

export default {
    components: {
        InputTypes,
        InputIdentify,
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const userId = computed(() => store?.state?.permissions?.userInfo?.id || '');
        const param = computed(() => store?.state?.permissions?.userInfo?.param || '');
        onMounted(() => {
            if (!userId.value) {
                router.push({ name: routeName.FORBIDDEN });
            }
        });
        const users = reactive({
            id: userId.value,
            account: '',
            password: '',
            verifyCode: '',
            errors: {
                account: '',
                password: '',
                verifyCode: '',
            },
            reFresh: false,
        });

        const isLoading = ref(false);
        const isPassVerified = ref(false);
        const getIsPassverifyCode = (isPass) => {
            isPassVerified.value = isPass;
            users.errors.verifyCode = '';
        };
        const validateAccount = (value) => {
            const { message } = textLength({
                value,
                min: 8,
                fieldName: '帳號',
            });
            users.errors.account = message;
        };
        const validatePassword = (value) => {
            const { message } = textLength({
                value,
                min: 8,
                fieldName: '密碼',
            });
            users.errors.password = message;
        };
        const validateVerifyCode = (value) => {
            if (value === '') {
                users.errors.verifyCode = '請輸入驗證碼';
            } else if (!isPassVerified.value) {
                users.errors.verifyCode = '請輸入正確的驗證碼';
            }
        };

        // 送出登入
        const login = (password) => {
            const data = {
                id: userId.value,
                myId: users.account,
                password,
                verifyCode: users.verifyCode,
                token: param.value,
                callBackParam: '',
            };
            postMemberVerifySubmit(data).then(res => {
                const token = res.data.ssoParam;
                const path = process.env.VUE_APP_API_PATH;
                const baseUrl = `${window.location.origin}${path}`;
                window.location.href = `${baseUrl}/ssoLogin?param=${token}`;
            }).catch(err => {
                if (err.data?.redirectUrl) {
                    return;
                }
                isLoading.value = false;
                openPopupCatchMessage(err);
                users.reFresh = true;
                users.account = '';
                users.password = '';
                users.verifyCode = '';
                isLoading.value = false;
            });
        };

        // 驗證後才送出
        const validValue = () => {
            validatePassword(users.password);
            validateAccount(users.account);
            validateVerifyCode(users.verifyCode);

            const {
                account,
                password,
                verifyCode,
            } = users.errors;

            if (account || password || verifyCode) {
                return;
            }
            isLoading.value = true;
            postEncrypt(users.password).then((res) => {
                login(res.data.encrypted);
            }).catch(() => {
                isLoading.value = false;
            });
        };

        const forgetPassword = () => {
            window.location = process.env.VUE_APP_SCV_FORGETPASSWORD;
        };

        return {
            ...toRefs(users),
            validValue,
            validateAccount,
            validatePassword,
            getIsPassverifyCode,
            forgetPassword,
            isLoading,
        };
    },
};
</script>
<style lang="scss" scoped>
</style>
